module.exports = __webpack_public_path__ + "static/img/kv.e2b7311.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/home/kv.jpg
// module id = rjOR
// module chunks = 1